<script>
export default {
	props:{
		id:{default:'page'},
		pageData:{required:true},
	},
	
	data(){
		return {
			isMapBusy:false,
		}
	},
	
	methods: {},
	
	mounted(){
		eventsBuffer.$on('mapBusyStatus', (data) => this.isMapBusy = data.status);
	},
	
	created(){}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/pages/near-programs.vue